import { Storage } from '@altirllc/shared/utils/storage';

export const storage = new Storage();
